export interface GuaCategory {
  id: string;
  name: string;
  icon: string;
  desc: string;
  color: 'primary' | 'accent' | 'secondary' | 'foreground';
  posts: number;
}

export const categories: GuaCategory[] = [
  { id: 'film', name: '影视综艺', icon: 'ri-movie-2-line', desc: '片场幕后、综艺名场面与演员幕后瓜', color: 'primary', posts: 1286 },
  { id: 'social', name: '社会热点', icon: 'ri-newspaper-line', desc: '全民关注的新闻事件与舆论现场', color: 'accent', posts: 2450 },
  { id: 'ent', name: '娱乐八卦', icon: 'ri-camera-lens-line', desc: '圈内大小事与网友大胆猜测', color: 'secondary', posts: 3092 },
  { id: 'tech', name: '科技互联网', icon: 'ri-flashlight-line', desc: '大厂动态、新品发布与行业讨论', color: 'foreground', posts: 987 },
  { id: 'life', name: '生活趣闻', icon: 'ri-community-line', desc: '身边的怪事、趣事与都市传说', color: 'primary', posts: 1433 },
  { id: 'sport', name: '体育电竞', icon: 'ri-gamepad-line', desc: '赛事复盘、选手动态与高光名场面', color: 'accent', posts: 762 },
];

export interface HotPost {
  id: string;
  title: string;
  summary: string;
  category: string;
  author: string;
  authorTag: string;
  time: string;
  discussions: number;
  votes: number;
  views: number;
  tags: string[];
  pinned?: boolean;
  fresh?: boolean;
  emoji: string;
}

export const hotPosts: HotPost[] = [
  {
    id: 'p1',
    title: '新剧《长风渡口》大结局台词反转刷屏，编剧在线回应争议',
    summary: '一句台词引全网狂欢。有人直呼"封神名场面"，有人觉得情感处理仓促，编剧深夜发长文回应，评论区瞬间分成两派吵了上万楼。',
    category: '影视综艺',
    author: '追剧阿铭',
    authorTag: '铁粉',
    time: '18分钟前',
    discussions: 12840,
    votes: 8921,
    views: 230000,
    tags: ['长风渡口', '大结局', '名场面'],
    pinned: true,
    emoji: '🎬',
  },
  {
    id: 'p2',
    title: '某头部主播带货翻车后首度发声，网友：这波危机公关你打几分？',
    summary: '直播间里的一句"选品失误"能挽回多少信任？道歉文案被逐字拆解，评论区吵得不可开交，支持者与质疑者各执一词。',
    category: '娱乐八卦',
    author: '吃瓜不吐籽',
    authorTag: '老瓜农',
    time: '42分钟前',
    discussions: 9820,
    votes: 5304,
    views: 176000,
    tags: ['带货', '危机公关', '道歉'],
    fresh: true,
    emoji: '📢',
  },
  {
    id: 'p3',
    title: '大学生在宿舍拍的宿舍生活视频突然爆红，评论区画风跑偏',
    summary: '一条平凡的宿舍日常为何引数十万人围观？有人求同款神器，有人晒自己的神仙室友，欢乐评论区看得停不下来。',
    category: '生活趣闻',
    author: '舍管阿姨看剧',
    authorTag: '快乐源泉',
    time: '1小时前',
    discussions: 7640,
    votes: 12003,
    views: 198000,
    tags: ['宿舍', '爆红', '搞笑'],
    emoji: '🏠',
  },
  {
    id: 'p4',
    title: '新旗舰发布会实测翻车？"低功耗宣传"被网友逐帧打脸',
    summary: '发布会喊出的惊人数字，实测却对不上。技术宅们连夜做了评测，评论区开始互相"对线"，到底谁在带节奏？',
    category: '科技互联网',
    author: '数码老张',
    authorTag: '极客',
    time: '2小时前',
    discussions: 6110,
    votes: 4450,
    views: 152000,
    tags: ['发布会', '评测', '功耗'],
    emoji: '🔋',
  },
  {
    id: 'p5',
    title: '地方文旅的"反向操作"走红：越劝退越有人去，网友吵翻了',
    summary: '官方亲自劝退游客的"反向宣传"居然带火了小众目的地。有网友说这才是真诚，也有人担忧景区体验会因此下降。',
    category: '社会热点',
    author: '在路上的人',
    authorTag: '旅行博主',
    time: '3小时前',
    discussions: 5320,
    votes: 7800,
    views: 134000,
    tags: ['文旅', '反向宣传', '小众旅游'],
    emoji: '🧭',
  },
  {
    id: 'p6',
    title: '总决赛抢七最后一球：裁判视角回放成全网热议焦点',
    summary: '终场哨响前的那一刻究竟有没有犯规？高清多角度回放被扒出，老球迷和新观众在评论区吵成一锅粥。',
    category: '体育电竞',
    author: '板凳席记者',
    authorTag: '懂球帝',
    time: '4小时前',
    discussions: 8890,
    votes: 6600,
    views: 210000,
    tags: ['总决赛', '争议判罚', '回放'],
    emoji: '🏀',
  },
];

export interface TrendItem {
  rank: number;
  title: string;
  heat: string;
  tag: string;
  delta: number;
}

export const trends: TrendItem[] = [
  { rank: 1, title: '#长风渡口大结局 台词反转#', heat: '1284万热度', tag: '爆', delta: 1 },
  { rank: 2, title: '#主播道歉文案逐字拆解#', heat: '976万热度', tag: '热', delta: 3 },
  { rank: 3, title: '#宿舍生活视频突然爆红#', heat: '820万热度', tag: '新', delta: 0 },
  { rank: 4, title: '#总决赛最后一球判罚争议#', heat: '753万热度', tag: '热', delta: -2 },
  { rank: 5, title: '#文旅反向宣传带火小城#', heat: '641万热度', tag: '热', delta: 2 },
  { rank: 6, title: '#新旗舰低功耗实测#', heat: '588万热度', tag: '新', delta: 0 },
  { rank: 7, title: '#综艺名场面考古#', heat: '472万热度', tag: '', delta: -4 },
  { rank: 8, title: '#打工人周五精神状态#', heat: '391万热度', tag: '', delta: 1 },
];

export interface GuaComment {
  id: string;
  author: string;
  level: string;
  content: string;
  likes: number;
  time: string;
  replies: number;
}

export const featuredComments: GuaComment[] = [
  {
    id: 'c1',
    author: '一颗小甜瓜',
    level: '铁杆瓜友',
    content:
      '那句台词我看了三遍没回过神，编剧这波确实大胆。但说真的，前面的铺垫要是再厚一点，结局会更有后劲，可惜了。',
    likes: 2312,
    time: '5分钟前',
    replies: 368,
  },
  {
    id: 'c2',
    author: '理性吃瓜人',
    level: '硬核讨论',
    content:
      '我不反对反转，但角色行为得符合人物逻辑啊。就为了反转而反转，看得我满头问号，编剧出来走两步讲讲？',
    likes: 1874,
    time: '22分钟前',
    replies: 512,
  },
  {
    id: 'c3',
    author: '深夜看片选手',
    level: '快乐源泉',
    content:
      '全程边哭边笑，配乐一响我鸡皮疙瘩都起来了。这个结局我能接受，至少给每个角色都留了个体面，比烂尾强太多。',
    likes: 1490,
    time: '31分钟前',
    replies: 96,
  },
  {
    id: 'c4',
    author: '显微镜女孩',
    level: '考据党',
    content:
      '你们没发现第二集就在埋伏笔吗？道具、背景板上的字全对上了，编剧藏得是真深，回头再看都是细节啊朋友们。',
    likes: 1102,
    time: '48分钟前',
    replies: 207,
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const siteStats: StatItem[] = [
  { value: '1200万+', label: '累计热议' },
  { value: '86万', label: '活跃瓜友' },
  { value: '3.2万+', label: '热门话题' },
  { value: '24h', label: '实时跟帖' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '大瓜网上的帖子和评论内容可靠吗？',
    a: '大瓜网聚合网友公开分享的热议话题，内容均来自用户参与和转载讨论。我们鼓励多方求证、理性讨论，对明显失实或恶意造谣的内容设有举报与人工复核机制，看到问题内容可一键举报。',
  },
  {
    q: '如何参与话题讨论并发表自己的观点？',
    a: '在任意热帖下方或话题讨论区直接输入你的看法即可发言，无需复杂操作。发言时请遵守社区公约，文明表达、就事论事，避免人身攻击与刷屏。',
  },
  {
    q: '为什么有些帖子会被折叠或删除？',
    a: '为维护讨论质量，涉及不实信息、引战辱骂、侵犯隐私、广告引流等违规内容会被系统自动折叠或由社区管理复核后处理。被折叠并非封禁，规范发言后不影响正常讨论。',
  },
  {
    q: '我可以把大瓜网的热门话题分享到其他平台吗？',
    a: '当然可以。每条热帖与话题都提供了站外分享入口，欢迎把有趣的讨论分享给朋友。转载到其他平台时建议注明来源，尊重原作者的观点表达。',
  },
  {
    q: '如何反馈意见或举报不友善内容？',
    a: '在帖子或评论右上角点击举报按钮即可提交，也可以向大瓜网官方反馈邮箱发送邮件说明情况，社区管理团队会尽快处理并跟进结果。',
  },
];

export interface ForumTopic {
  id: string;
  title: string;
  excerpt: string;
  meta: string;
  reads: string;
  tone: 'hot' | 'calm' | 'fun';
}

export const forumTopics: ForumTopic[] = [
  { id: 'f1', title: '【观后感】长风渡口大结局，你站哪一派？', excerpt: '理性派与感动派在这条帖子里和平共处……', meta: '阿铭聊剧', reads: '128.4万', tone: 'hot' },
  { id: 'f2', title: '宿舍生活爆红后，评论区变成了快乐许愿池', excerpt: '大家开始晒神仙室友，画风逐渐离谱……', meta: '快乐补给站', reads: '96.2万', tone: 'fun' },
  { id: 'f3', title: '实测数据来了：低功耗宣传到底注了多少水？', excerpt: '逐帧拆解发布会，结论可能让你意外……', meta: '极客实验室', reads: '81.7万', tone: 'calm' },
  { id: 'f4', title: '地方文旅反向操作，是真诚还是摆烂？', excerpt: '两条路线吵了一个晚上，各有各的道理……', meta: '在路上的人', reads: '64.3万', tone: 'calm' },
];

export const trendingTags: string[] = [
  '长风渡口',
  '名场面',
  '危机公关',
  '宿舍神器',
  '低功耗',
  '反向旅游',
  '总决赛',
  '考古综艺',
  '吃瓜群众',
  '明星周边',
];